<template >
  <div v-if="this.modelMenuOpen" class="model-menu">
    <div class="model-menu-top">
      <div class="menu_left_wrapper">
        <a @click="openModelMenu()" href="#" class="menu_left_link active">
          Модельный ряд
        </a>
      </div>
      <div class="logo-wrapper">
        <img @click="this.$router.push('/')" src="@/assets/logo.svg" alt="" />
      </div>
      <div class="close" @click="openModelMenu()">
        <img src="@/assets/icon/close.svg" alt="" />
      </div>
    </div>

    <div @click="openModelMenu()" class="model-menu-top-mobile">
      <div class="item">
        <img src="@/assets/icon/chevron-left.svg" alt="" />
      </div>
      <div class="item text">Модельный ряд</div>
    </div>

    <div class="model-menu-list">
      <div
        v-for="(category, index) in this.filteredCategories"
        :key="index"
        class="model-menu-list-item"
      >
        <div v-if='category.count_active_product != 0'
          class="model-menu-list-item-top"
          @click="dropdownCategory(category.id)"
        >
          {{ category.name }}
          <div class="arrow-back" >
            <img :class="{'arrow-reverse': category.active}" src="@/assets/icon/arrow-bottom.svg" alt="" />
          </div>
        </div>
        <div v-if="category.active" class="subcategories-box">
          <div

            v-for="(subcategory, index_sub) in category.subcategories"
            :key="index_sub"
          >
          <div class="subcategory" v-if='subcategory.count_active_product != 0' @click="showDoors(subcategory.id, subcategory.name)">
              {{ subcategory.name }}
          </div>

          </div>
        </div>
      </div>
    </div>

    <div class="doors_box_mobile" v-if="this.leftBarWithDoors">
      <div class="row" v-if='this.filteredDoors.length != 0'>
        <div
          v-for="(door, index) in this.filteredDoors"
          :key="index"
          class="col-6 col-sm-6"
        >

          <div class="item" v-on:click="addDoorImageInPolygon(door)">
            <img class="door-photo" :src="door.image" alt="" />
            <p>
              {{ door.name }}
            </p>
            <span>
              {{ door.price }} ₽
            </span>
          </div>
        </div>
      </div>
      <div class="row" v-if='this.filteredDoors.length === 0'>
        По вашему запросу ничего не найдено
      </div>
    </div>
  </div>

  <div class="fullpage_control_wrapper" v-if="this.isFullpage">
    <div v-on:click="closeFullPage()">
      <img src="@/assets/icon/close_full.svg" alt="" />
    </div>
    <div v-on:click="editPolygon()">
      <img src="@/assets/icon/show_doors.svg" alt="" />
    </div>
    <div v-on:click="saveImage()">
      <img src="@/assets/icon/export.svg" alt="" />
    </div>
  </div>

  <div class="fullpage_control_doors_wrapper" v-if="this.isFullpage">
    <div v-if="poligons.length > 0" class="doors_control">
      <div
        v-for="(poligon, index) in this.poligons"
        :key="index"
        class="door_button"
        :class="{ door_active: poligon.active }"
        v-on:click="setActive(index)"
      >
        <div>Дверь {{ index + 1 }}</div>
        <button class="door_button_remove" v-on:click="removeDoor(index)">
          <img src="@/assets/icon/x_black.svg" alt="x" />
        </button>
      </div>
      <div class="add_door_button" v-on:click="addPolygon()">
        <img src="@/assets/icon/plus.svg" alt="Добавить" />
      </div>
    </div>
    <div v-else class="doors_control">
      <div class="add_door_button" v-on:click="addPolygon()">
        <img src="@/assets/icon/plus.svg" alt="Добавить" />
      </div>
    </div>
  </div>


  <div
      class="mobile_filter_menu_wrapper"
      v-bind:class="{
        'mobile_filter_show': this.showMobileFilter
      }"
  >
    <div class="menu_right_mobile_header" style="display: block !important;">
      <div style="position: absolute; left: 15%; width: 40px;" @click="closeMobileFilter">
        ×
      </div>
      Фильтры
    </div>

    <div class="menu_right_link_box">
      <div
          class="menu_right_link_content"
          id='properties_mobile'
      >
        <div class="menu_right_link" style="font-style: normal; font-weight: 400; font-size: 24px; line-height: 29px; color: #181818; margin-bottom: 15px;">
          Типы дверей
        </div>
        <form>
          <div
              v-for="(item, index) in this.door_types"
              :key="index"
              class=""
          >
            <div
                class="filter-item-box"
            >
              <label for="">{{ item.name }}</label>
              <input
                  v-model="item.checked"
                  type="checkbox"
              />
            </div>
          </div>
          <div class="properties_buttons_wrapper">
            <div class="menu_right_link_content_bottom_mobile" style='margin-bottom: 20px'>
              <a class="inverse button" @click="dropMobileFilter()"
              >Сбросить</a
              >
            </div>
            <div class="menu_right_link_content_bottom_mobile">
              <a class="inverse button" @click="filterDoors()"
              >Сохранить</a
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="content" :class="{ 'd-none': this.modelMenuOpen }">
    <div class="header__mobile">
      <Header/>
    </div>
    <div class="top_content">
      <div class="container">
        <div class="logo-wrapper" >
          <img src="@/assets/logo.svg" alt="" style='cursor: pointer;' @click="$router.push({ name: 'home' })"/>
        </div>
        <div class="menu">
          <div class="menu_left">
            <a href="#" @click="openModelMenu()">
              <div class="burger_wrapper">
                <img src="@/assets/icon/burger.svg" alt="" />
              </div>
            </a>
            <div class="menu_left_wrapper">
              <a
                @click="openModelMenu()"
                href="#"
                class="menu_left_link active"
              >
                Модельный ряд
              </a>
            </div>
          </div>
          <div
            class="menu_right"
            v-bind:class="{
              menu_right_link_box_open_in_mobile: this.filterBoxVisibled,
            }"
          >
            <div class="menu_right_mobile_header" @click="openFilterInMobile()">
              Фильтры
            </div>
            <a href="#" class="menu_right_mobile" @click="openFilterInMobile()">
              <img src="@/assets/icon/options.svg" alt="" />
            </a>
            <div class="menu_right_link_box" id="colors">
              <a href="#" class="menu_right_link" @click="openColorBox()">
                Цветовая гамма
              </a>
              <div class="menu_right_link_content_colors menu_right_link_content" v-if="this.colorBoxVisibled">
                <div class="menu_right_link_content_top">
                  <h3>Цветовая гамма</h3>
                  <div class="color-list">
                    <div
                      class="color-list-item"
                      v-for="(color, index) in this.filteredColors"
                      :key="index"
                      v-tooltip="color.name"
                    >
                      <div class="" :class="{ active: color.active }">
                        <div class="delete" @click="this.addColor(color.id)">×</div>
                        <img
                          :src="color.image"
                          :alt="color.name"
                          @click="this.addColor(color.id)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="properties_buttons_wrapper">
                  <div class="menu_right_link_content_bottom">
                    <a class="inverse button" @click="dropColors()">
                      Сбросить
                    </a>
                  </div>
                  <div class="menu_right_link_content_bottom">
                    <a class="inverse button" @click="filterDoors()">
                      Сохранить
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="menu_right_link_box">
              <a href="#" class="menu_right_link" @click="openPropertyBox()">
                Свойства
              </a>
              <div
                class="d-none menu_right_link_content"
                :class="{ visible: this.propertyBoxVisibled }"
                id='properties_mobile'
              >
                <form id="properties">
                  <div class="menu_right_link_content_top">
                    <h3>Свойства</h3>
                    <div class="property-list" v-if="this.filteredProperties.length > 0">
                      <div
                        v-for="(property, index) in this.filteredProperties"
                        :key="index"
                        class=""
                      >
                        <div
                          v-if="property.type == 'Чекбокс'"
                          class="filter-item-box"
                        >
                          <label for="">{{ property.name }}</label>
                          <input
                            :typeForBack="property.type"
                            :id="'p' + property.id"
                            type="checkbox"
                          />
                        </div>

                        <div
                          v-if="property.type == 'Диапазон'"
                          class="filter-item-box"
                        >
                          <label for="">{{ property.name }}</label>
                          <div class="diapason-input-box">
                            <label>от:</label>
                            <input
                              :typeForBack="property.type"
                              :id="'p' + property.id + 'min'"
                              type="number"
                              value="0"
                            />
                            <label>до:</label>
                            <input
                              :typeForBack="property.type"
                              :id="'p' + property.id + 'max'"
                              type="number"
                              value="0"
                            />
                          </div>
                        </div>

                        <div
                          v-if="property.type == 'Список'"
                          class="filter-item-box"
                        >
                          <label for="">{{ property.name }}</label>
                          <select
                            :typeForBack="property.type"
                            :id="'p' + property.id"
                          >
                            <option value="0" selected>
                              Выберите значение
                            </option>
                            <option
                              v-for="(
                                list_property_value, index
                              ) in property.list_property_value"
                              :key="index"
                              :value="list_property_value.id"
                            >
                              {{ list_property_value.value }}
                            </option>
                          </select>
                        </div>

                        <div
                          v-if="property.type == 'Текст'"
                          class="filter-item-box"
                        >

                          <label for="">{{ property.name }}</label>
                          <select
                            :typeForBack="property.type"
                            :id="'p' + property.id"
                            v-if='property.filtered_list_property_text_value.length === 0'
                          >
                            <option value="0" selected>
                              Выберите значение
                            </option>
                            <option
                              v-for="(
                                list_property_value, index
                              ) in property.list_property_text_value"
                              :key="index"
                              :value="list_property_value.value"
                            >
                              {{ list_property_value.value }}
                            </option>
                          </select>

                          <select
                            :typeForBack="property.type"
                            :id="'p' + property.id"
                            v-if='property.filtered_list_property_text_value.length != 0'
                          >
                            <option value="0" selected>
                              Выберите значение
                            </option>
                            <option
                              v-for="(
                                list_property_value, index
                              ) in property.filtered_list_property_text_value"
                              :key="index"
                              :value="list_property_value.value"
                            >
                              {{ list_property_value.value }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="property-list" v-else>Нет доступных свойств</div>
                  </div>
                  <div style="font-style: normal; font-weight: 400; font-size: 24px; line-height: 29px; color: #181818; margin-bottom: 15px;">
                    Типы дверей
                  </div>
                  <div style="margin-bottom: 30px;">
                    <div
                        v-for="(item, index) in this.door_types"
                        :key="index"
                        class=""
                    >
                      <div
                          class="filter-item-box"
                      >
                        <label for="">{{ item.name }}</label>
                        <input
                            v-model="item.checked"
                            type="checkbox"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="properties_buttons_wrapper">
                    <div class="menu_right_link_content_bottom" v-if="this.filteredProperties.length > 0">
                      <a class="inverse button" @click="dropProperties()"
                        >Сбросить</a
                      >
                    </div>
                    <div class="menu_right_link_content_bottom" v-if="this.filteredProperties.length > 0">
                      <a class="inverse button" @click="addProperties()"
                        >Сохранить</a
                      >
                    </div>
                    <div class="menu_right_link_content_bottom_mobile" style='margin-bottom: 20px'>
                      <a class="inverse button" @click="dropAllfilter()"
                        >Сбросить</a
                      >
                    </div>
                    <div class="menu_right_link_content_bottom_mobile">
                      <a class="inverse button" @click="filterDoorsInMobile()"
                        >Сохранить</a
                      >
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if='this.selectedCategory != null' class="container">
       <div class="selectedCategories">
         <div class='item'>
           <div class="item_button">
             {{ this.selectedCategoryName }}
           </div>
           <div class='deleteSelectedCategories' @click='deleteSelectedCategory()'>
             ×
           </div>
         </div>
       </div>
     </div>
    </div>
    <div class="main_content">
      <div class="container">
        <div class="photo_content">
          <div v-if="this.leftBarWithDoors" class="doorChoiceBlock">
            <div class="search_box">
              <input
                type="search"
                name=""
                placeholder="Поиск"
                v-model="search"
              />
            </div>
            <div class="doors_box" v-on:scroll.passive='handleScroll'>
              <div
                v-for="(door, index) in this.filteredDoors"
                :key="index"
                class="item"
                v-on:click="addDoorImageInPolygon(door)"
              >
                <img class="product_image" :src="door.image" alt="" />
                <p>
                  {{ door.name }}
                </p>
                <span>
                  {{ door.price }} ₽
                </span>
              </div>
              <div v-if='this.filteredDoors.length === 0' class="empty_message">
                По вашему запросу ничего не найдено
              </div>
            </div>
            <div v-if='this.nextPageBlockShow' class="next_block">
              <img @click='nextDoorsPage()' src="@/assets/icon/chevrons-down.svg" alt="">
            </div>
          </div>
          <div
            class="photo_content_main"
            :class="{ 'photo_content_main-choice': leftBarWithDoors }"
          >
            <h4 id="choose-door-title" v-if="!this.doorChoiceVisibled">
              Выберите область двери при помощи рамки.
            </h4>
            <div
              class="photo_wrapper_block"
              id="image_block"
              :class="{ fullpage: isFullpage }"
            >
              <div
                class="photo_control_wrapper"
                v-if="this.doorChoiceVisibled && !this.isFullpage"
              >
                <div class="control_icon" v-on:click="saveImage()">
                  <img src="@/assets/icon/download.svg" alt="" />
                </div>
                <div class="control_icon" v-on:click="editPolygon()">
                  <img
                    v-if="!edit"
                    src="@/assets/icon/globe_disable.svg"
                    alt=""
                    style="width: 29px; height: 29px"
                  />
                  <img
                    v-else
                    src="@/assets/icon/globe.svg"
                    alt=""
                    style="width: 29px; height: 29px"
                  />
                </div>
                <button class="border-complete-button" v-if="getReferrerDoorInfo" v-on:click="insertDoor()">Вставить дверь</button>
              </div>
              <div
                  class="photo_control_wrapper-mobile"
                  v-if="this.doorChoiceVisibled && !this.isFullpage"
              >
                <div class="control_icon" v-on:click="openMobileFilter()">
                  <img src="@/assets/icon/filter.svg" alt="" />
                </div>
              </div>
              <div
                class="photo_fullpage_control"
                v-if="this.doorChoiceVisibled && !this.isFullpage"
              >
                <div class="control_icon" v-on:click="openFullPage()">
                  <img src="@/assets/icon/maximize.svg" alt="" />
                </div>
              </div>
              <div
                  class="open-filter-mobile"
                  v-if="this.doorChoiceVisibled && !this.showMobileDoorsBox "
              >
                <div class="open-filter__button" v-on:click="this.showMobileDoorsBox = true">
                  Попробовать другие двери
                </div>
              </div>
              <canvas id="c" ref="can" width="800" height="700"></canvas>
            </div>
            <div
                v-if="!this.doorChoiceVisibled"
                id="mobile_first_step_buttons"
                class="photo_content_buttons_wrapper"
            >
              <a class="button_cancel" v-on:click="resetAll()"> Отменить </a>
              <a class="button" v-on:click="saveFirstPolygon()"> Сохранить </a>
            </div>
              <div class="new_doors_box_mobile" v-if="this.doorChoiceVisibled && this.showMobileDoorsBox && this.filteredDoors.length > 0">
                <div class="close-doors-box" @click="this.showMobileDoorsBox = false">
                  <img src="@/assets/icon/x.svg" alt="x" />
                </div>
                  <div class="row" v-if='this.filteredDoors.length != 0'>
                      <div
                          v-for="(door, index) in this.filteredDoors"
                          :key="index"
                          class="col-6 col-sm-6"
                      >

                          <div class="item" v-on:click="addDoorImageInPolygon(door)">
                              <img class="door-photo" :src="door.image" alt="" />
                              <p>
                                  {{ door.name }}
                              </p>
                              <span>
                                {{ door.price }} ₽
                              </span>
                          </div>
                      </div>
                  </div>
              </div>
            <div class="row"
                 style="justify-content: center; margin-bottom: 30px;"
                 v-if='this.doorChoiceVisibled && this.showMobileDoorsBox && this.filteredDoors.length === 0'>
              По вашему запросу ничего не найдено
            </div>

            <div class="mobile-color-list-wrapper" v-if="this.doorChoiceVisibled" style="width: 100%;">
              <div class="menu_right_link_box" id="colors_mobile" style="width: inherit;">
                <div class="menu_right_link_content_colors menu_right_link_content" style="position: relative !important; width: auto !important; top: 0 !important;">
                  <div class="menu_right_link_content_top">
                    <h3>Цветовая гамма</h3>
                    <div class="color-list" style="padding-top: 10px;">
                      <div
                          class="color-list-item"
                          v-for="(color, index) in this.filteredColors"
                          :key="index"
                          v-tooltip="color.name"
                      >
                        <div class="" :class="{ active: color.active }">
                          <div class="delete" @click="this.addMobileColor(color.id)">×</div>
                          <img
                              :src="color.image"
                              :alt="color.name"
                              @click="this.addMobileColor(color.id)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="properties_buttons_wrapper" style="display: flex !important; justify-content: center !important;">
                    <div class="menu_right_link_content_bottom" style="display: flex !important;">
                      <a class="inverse button" @click="dropColors()" style="padding: 15px;">
                        Сбросить
                      </a>
                    </div>
                    <!--<div class="menu_right_link_content_bottom" style="display: flex !important;">
                      <a class="inverse button" @click="filterDoors()" style="padding: 15px;">
                        Сохранить
                      </a>
                    </div>-->
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="!this.doorChoiceVisibled"
              id="mobile_buttons_hidden"
              class="photo_content_buttons_wrapper"
            >
              <a class="button_cancel" v-on:click="resetAll()"> Отменить </a>
              <a class="button" v-on:click="saveFirstPolygon()"> Сохранить </a>
            </div>
            <div
              v-else
              class="photo_content_buttons_wrapper photo_content_control doors_control_wrapper"
              v-bind:class="{
              'show_doors_control': showMobileDoorsControl
              }"
            >
              <div v-if="poligons.length > 0" class="doors_control">
                <div
                  v-for="(poligon, index) in this.poligons"
                  :key="index"
                  class="door_button"
                  :class="{ door_active: poligon.active }"
                  v-on:click="setActive(index)"
                >
                  <div>Дверь {{ index + 1 }}</div>
                  <button
                    class="door_button_remove"
                    v-on:click="removeDoor(index)"
                  >
                    <img src="@/assets/icon/x.svg" alt="x" />
                  </button>
                </div>
                <div class="add_door_button" v-on:click="addPolygon()">
                  <img src="@/assets/icon/plus.svg" alt="Добавить" />
                </div>
              </div>
              <div v-else class="doors_control">
                <div class="add_door_button" v-on:click="addPolygon()">
                  <img src="@/assets/icon/plus.svg" alt="Добавить" />
                </div>
              </div>
              <a class="button desktop_button" v-on:click="toOrder()"><img src="@/assets/icon/shopping-cart.svg" alt=""> Заказать </a>
            </div>
            <a v-if="doorChoiceVisibled" class="mobile_button_order mobile_button" style="position: fixed; bottom: 15%; right: 5%; z-index: 99999;" v-on:click="toOrder()"><img src="@/assets/icon/shopping-cart.svg" alt="Заказать"></a>
            <div v-if="doorChoiceVisibled" class="mobile-ext-functions" @click="this.showMobileDoorsControl = !this.showMobileDoorsControl">
              <span v-if="!showMobileDoorsControl">Доп. функции</span>
              <span v-else>Скрыть</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { fabric } from "fabric";
import Perspective from "perspectivejs";
import { mapGetters, mapMutations } from "vuex";
import { enviroment } from "@/services/config";
import tooltip from "@/directives/tooltip"

import {
  getCategories,
  getColors,
  getProductsByCategoryId,
  getProperties,
  getProductIdsByProperties,
  getColorsInCategory,
  getPropertiesTextValueFiltered
} from "../services/methods.js";

import { baseUrlStorage } from "../services/config.js";
import Header from "@/components/include/Header";

export default {
  name: "ChoiceDoorsView",
  directives: {
    tooltip
  },
  components: {
    Header
  },
  data() {
    return {
      confirmImage: false,
      leftBarWithDoors: false,
      modelMenuOpen: false,
      doorsWasShow: 20,
      nextPageBlockShow: true,
      doorChoiceVisibled: false,
      colorBoxVisibled: false,
      filterBoxVisibled: false,
      propertyBoxVisibled: false,
      colors: [],
      categories: [],
      doors: [],
      properties: [],
      filteredDoors: [],
      filteredCategories: [],
      filteredProperties: [],
      selectedCategory: null,
      selectedCategoryName: null,
      selectedColors: [],
      selectedProperties: [],
      filteredColors: [],
      search: "",
      image: null,
      showMobileFilter: false,
      showMobileDoorsControl: false,
      poligons: [],
      poligon_points: [],
      canvas: null,
      edit: true,
      original_image_size: {
        width: null,
        height: null,
        type: "square",
      },
      isFullpage: false,
      mouseYcoord: null,
      door_types: [
        {
          type: "1",
          name: 'Глухая',
          checked: false,
        },
        {
          type: "2",
          name: 'Со стеклом',
          checked: false,
        },
        {
          type: "3",
          name: 'С зеркалом',
          checked: false,
        },
      ],
      showMobileDoorsBox: true,
    };
  },
  mounted() {
    if (!this.getImage) {
      this.$router.push({ name: "home" });
      return;
    }
    if (this.isMobileOrTablet) {
      this.canvas = new fabric.Canvas("c", {
        allowTouchScrolling: true,
        controlsAboveOverlay: true
      });
    } else {
      this.canvas = new fabric.Canvas("c");
    }

    this.canvas.centeredRotation = true;
    this.canvas.centeredScaling = true;
    this.canvas.setWidth(
      document.getElementById("image_block").parentElement.clientWidth
    );
    this.canvas.selection = false;
    if (this.getImage.src) {
      let img = new Image();
      img.onload = () => {
        let cnvImg = new fabric.Image(img, {
          left: 0,
          top: 0,
          height: img.height,
          width: img.width,
          scaleX: this.canvas.width / img.width,
        });
        this.canvas.setHeight(img.height * (this.canvas.width / img.width));
        this.canvas.setBackgroundImage(
          cnvImg,
          () => {
            this.canvas.renderAll();
          },
          {
            scaleX: this.canvas.width / img.width,
            scaleY: this.canvas.height / img.height,
          }
        );

        this.original_image_size = {
          width: img.width,
          height: img.height,
          type: img.width > img.height ? "gorizontal" : "vertical",
        };

        // Если на фото нашлись двери
        if(this.getDoorsPos !== null && this.getDoorsPos.length !== 0)
        {
            for (const poly of this.getDoorsPos) {
                this.addPolygon(poly);
            }
            this.saveFirstPolygon();
            console.log(document.body.clientHeight);
            this.$swal({
                    target: document.body.clientHeight < 1000 ? 'body' : '#image_block',
                    customClass: {
                        container: 'position-absolute' + (document.body.clientHeight < 1000 ? ' mobile-popup' : ''),
                    },
                    position: 'bottom',
                    title: "Мы правильно опредилили границы двери?",
                    showCancelButton: true,
                    confirmButtonText: "Да",
                    cancelButtonText: "Нет",
                }).then((result) => {
                    // Да
                    if(result.value)
                    {
                        if(this.getReferrerDoorInfo && this.getReferrerDoorInfo.length > 0)
                            this.insertDoor();
                    }
                });
        }
        else
        {
            this.addPolygon();
        }
    };
      img.src = this.getImage.src;
    }
    //window.addEventListener("resize", this.resizeHandler(null, null));
  },
  beforeUnmount() {
    //window.removeEventListener("resize", this.resizeHandler);
  },
  async created() {
    this.categories = await this.getCategories();
    this.filteredCategories = this.categories;

    const referrerDoor = this.getReferrerDoorInfo
    if (referrerDoor && referrerDoor.length > 0) {
      if (referrerDoor[0].category_id) {
        this.selectedCategory = referrerDoor[0].category_id;
        let findCategoryName = false;
        this.filteredCategories.forEach((category) => {
          if (findCategoryName) {
            return;
          }
          if (category.id === this.selectedCategory) {
            this.selectedCategoryName = category.name;
            findCategoryName = true;
          }
          category.subcategories.forEach((subcategory) => {
            if (subcategory.id === this.selectedCategory) {
              this.selectedCategoryName = subcategory.name;
              findCategoryName = true;
            }
          })
        });
      }
    }
    this.colors = await this.getColors();
    this.filteredColors = this.colors;
    this.doors = await this.getDoors();
    if (referrerDoor && referrerDoor.length > 0) {
      let index = this.doors.findIndex((door) => door.id === referrerDoor[0].id)
      this.swap(this.doors, 0, index);
      if (referrerDoor[0].category_id) {
        this.selectedCategory = referrerDoor[0].category_id;
      }
    }
    await this.filterDoors();
    this.properties = await this.getProperties();
    this.properties.forEach((property, i) => {
      property.filtered_list_property_text_value = [];
    });
    this.filteredProperties = this.properties;
  },
  watch: {
    search(value) {
      if (this.selectedCategory) {
        this.filterDoors();

        this.filteredDoors = this.filteredDoors.filter(
          (door) => door.categoryId == this.selectedCategory
        );
      }

      let doors = [];

      if (value.length >= 3) {
        /*this.doors.forEach((item) => {
          if (item.name.toLowerCase().indexOf(value.toLowerCase()) != -1) {
            doors.push(item);
          }
        });

        this.filteredDoors = doors;*/
        this.filterDoors();
      }
      if(value.length === 0){
        this.filterDoors();
      }
    },
  },
  computed: {
    ...mapGetters(["getImage", "getDoorsPos", "getReferrerDoorInfo"]),
    isMobileOrTablet() {
      let check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  methods: {
    addMobileColor(id) {
      if (this.filteredColors.find((color) => color.id === id).active) {
        this.filteredColors.find((color) => color.id === id).active = false;
        this.selectedColors = [];
        this.colors.forEach((colors, i) => {
          colors.active = false;
        });
      } else {
        this.selectedColors = [];
        this.colors.forEach((colors, i) => {
          colors.active = false;
        });
        this.addColor(id);
      }

      this.filterDoors();
    },
    openMobileFilter() {
      //this.addPolygon();
      this.showMobileFilter = true;
    },
    closeMobileFilter() {
      //this.removeDoor(this.poligons.length - 1);
      this.showMobileFilter = false;
      //this.showMobileDoorsBox = false;
    },
    swap(arr, a, b) {
      arr[a] = arr.splice(b, 1, arr[a])[0];
    },
    dropAllfilter(){
      this.door_types.forEach((item) => {
        item.checked = false;
      });
      this.dropColors();
      this.dropProperties();
      //this.openFilterInMobile();
      this.colorBoxVisibled = false;
      this.propertyBoxVisibled = false;
      //if (window.screen.width < 1000) {
      //  this.removeDoor(this.poligons.length - 1);
      //  this.showMobileDoorsBox = false;
     // }
    },
    dropMobileFilter() {
      this.door_types.forEach((item) => {
        item.checked = false;
      });
      this.dropProperties();
      this.colorBoxVisibled = false;
      this.propertyBoxVisibled = false;
    },
    dropProperties(){
      this.selectedProperties = [];

      let inputs = document.getElementById('properties').querySelectorAll('input');
      let selects = document.getElementById('properties').querySelectorAll('select');
      inputs.forEach(input => {
          if (input.type === "number") {
            input.value = 0;
          }
          if (input.type === "checkbox") {
            input.checked = false;
          }
        }
      );

      selects.forEach(select => {
          select.value = 0;
        }
      );

      this.addProperties()
    },
    dropColors(){
      this.selectedColors = [];

      this.colors.forEach((colors, i) => {
        colors.active = false;
      });

      this.filterDoors();
    },
    deleteSelectedCategory(){
      this.selectedCategory = null;
      this.filterDoors();
      this.filteredColors = this.colors;
    },
    filterDoorsInMobile(){
      this.addProperties();
      this.filterDoors();
      this.openColorBox();
      this.openPropertyBox();
      this.openFilterInMobile();
      this.openModelMenu();
      this.leftBarWithDoors = true;
      this.showMobileFilter = false;
    },
    handleScroll(){
      if (document.querySelector('.doors_box').scrollHeight === document.querySelector('.doors_box').scrollTop + document.querySelector('.doors_box').clientHeight) {
        this.nextDoorsPage();
      }
    },
    nextDoorsPage(){
      if (this.nextPageBlockShow) {
        this.doorsWasShow = this.doorsWasShow + 20;
        this.filterDoors();
      }
    },
    ...mapMutations(["setPreview", "setDoorsCount", "setDoorsName"]),
    resetAll() {
      this.$swal
        .fire({
          title: "Предупреждение",
          text: "Вы уверены, что хотите сбросить все?",
          showCancelButton: true,
          confirmButtonText: "Да",
          cancelButtonText: "Отмена",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ path: "/" });
            return;
          }
        });
    },
    toOrder() {
      let image_data = null;
      let doors_name = '';
      this.poligons.forEach((item) => {
        if (item.door_name) {
          doors_name += item.door_name + ';\n'
        }
      })
      try {
        image_data = document.getElementById("c").toDataURL("image/jpeg");
      } catch (e) {
        //console.log(e);
      }
      this.setPreview(image_data);
      this.setDoorsCount(this.poligons.length);
      this.setDoorsName(doors_name);

      this.$router.push({
        name: "order",
      });
    },
    async filterDoors() {
      this.filteredDoors = this.doors;
      this.filteredCategories = this.categories;
      this.filteredProperties = this.properties;
      if (this.selectedCategory != null) {
        let filterIds = new Set();
        this.filteredDoors = this.filteredDoors.filter(
          (door) => {
            if (door.categoryId == this.selectedCategory) {
              door.properties.forEach((property) => {filterIds.add(property.id)})
              return true
            }
            return false
          }
        );
        this.filteredProperties = this.properties.filter((property) => filterIds.has(property.id))

        for (const item of this.filteredProperties) {
          if (item.type === "Текст") {
            let productIds = [];
            let values = new Set();
            this.filteredDoors.forEach((item, i) => {
              productIds.push(item.id);
            });

            const response = await getPropertiesTextValueFiltered({
                "property_id": item.id,
                "product_ids": productIds
            });

            response.data.properties.forEach((item, i) => {
              values.add(item.value)
            });

            item.filtered_list_property_text_value = item.list_property_text_value.filter((value) => values.has(value.value))
          }
        }
          this.filteredColors.forEach((color, index) => {
              let indexDoor= this.filteredDoors.findIndex((door) => door.colorId === color.id)
              if (indexDoor != -1){
                  this.swap(this.filteredColors, 0, index)
              }
          });
      }

      let types = []
      this.door_types.forEach((item) => {
        if (item.checked) {
          types.push(item.type)
        }
      });

      if (types.length > 0) {
        console.log(types);
        this.filteredDoors = this.filteredDoors.filter((door) => types.includes(door.type))
      }

      if (this.selectedColors.length) {
        this.filteredDoors = this.filteredDoors.filter((door) =>
          this.selectedColors.includes(door.colorId)
        );//если у выбранной двери есть хотя бы один из выбранных цветов, то берем ее в наш массив
          if(this.filteredDoors.length === 0){
              this.deleteSelectedCategory();
          }
      }

      if (this.selectedProperties.length) {
        let data = {
          properties: this.selectedProperties,
        };

        const response = await getProductIdsByProperties(data);
        const productIds = response.data.productIds;
        this.filteredDoors = this.filteredDoors.filter((door) =>
          productIds.includes(door.id)
        );

        let filterCategories = [];

        this.filteredDoors.forEach((door) => filterCategories.push(door.categoryId))

        this.filteredCategories = this.categories.filter((category) => {
          let isSubcategory = false;

          category.subcategories.forEach((subcategory) => {
            if (filterCategories.includes(subcategory.id)) {
              isSubcategory = true;
              return;
            }
          })

          return filterCategories.includes(category.id) || isSubcategory;
        }
        );
      }

      let searchedDoors = [];

      if (this.search.length >= 3) {
        this.filteredDoors.forEach((item) => {
          if (item.name.toLowerCase().indexOf(this.search.toLowerCase()) != -1) {
            searchedDoors.push(item);
          }
        });

        this.filteredDoors = searchedDoors;
      }

      let filterDoorsForPage = [];

      this.filteredDoors.forEach((item, i) => {
        if (i < this.doorsWasShow) {
          filterDoorsForPage.push(item);
        }
      });

      this.filteredDoors = filterDoorsForPage;

      if (this.filteredDoors.length < this.doorsWasShow) {
        this.nextPageBlockShow = false;
      } else {
        this.nextPageBlockShow = true;
      }

      this.colorBoxVisibled = false;
      this.showMobileFilter = false;
    },
    addColor(colorId) {
      if (this.filteredColors.find((color) => color.id == colorId).active) {
        this.filteredColors.find((color) => color.id == colorId).active = false;

        let index = this.selectedColors.indexOf(colorId);
        if (index > -1) {
          // only splice array when item is found
          this.selectedColors.splice(index, 1); // 2nd parameter means remove one item only
        }
      } else {
        this.filteredColors.find((color) => color.id == colorId).active = true;
        this.selectedColors.push(colorId);
      }
    },
    openFilterInMobile() {
      if (!this.confirmImage) return

      if (window.screen.width <= 1000) {
        let content = document.getElementsByClassName("content")[0]; //console.log(content)
      }

      this.filterBoxVisibled = !this.filterBoxVisibled;

      this.openColorBox();
      this.openPropertyBox();
    },
    openColorBox() {
      if (!this.confirmImage) return

      this.colorBoxVisibled = !this.colorBoxVisibled;
    },
    async initCategoryColors(){
      const colorsResponse = await getColorsInCategory(this.selectedCategory);
      let colorsIds = new Set();

      colorsResponse.data.colors.forEach((item, i) => {
        colorsIds.add(item.color_id);
      });

      this.filteredColors = this.colors.filter((color) => colorsIds.has(color.id))
    },
    async showDoors(categoryId, categoryName) {


      this.selectedCategory = categoryId;
      this.selectedCategoryName = categoryName;

      if (window.screen.width > 1000) {
        this.modelMenuOpen = false;
      }

      this.leftBarWithDoors = true;

      this.filterDoors();
      await this.initCategoryColors();
    },
    dropdownCategory(id) {
      //change
      let categories = this.categories.filter((category) => category.id != id);
      categories.forEach((category) => {
        category.active = false;
      });
      //change
      let category = this.categories.find((category) => category.id === id);
      category.active = !category.active;
    },
    openModelMenu() {
      if (!this.confirmImage) return;

      this.modelMenuOpen = this.modelMenuOpen ? false : true;

      if (window.screen.width < 1000) {
        this.leftBarWithDoors = false;
      }
      //change
      this.categories.forEach((category) => {
        category.active = false;
      });
    },
    async getDoors(categoryId) {
      this.selectedCategory = categoryId;
      const response = await getProductsByCategoryId(categoryId);

      const products = response.data.products.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          price: item.price,
          image: baseUrlStorage + item.image,
          categoryId: item.category_id,
          colorId: item.color_id,
          properties: item.properties,
          type: item.type
        };
      });

      return products;
    },
    async getCategories() {
      const response = await getCategories();
      const categories = response.data.categories.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          subcategories: item.subcategories,
          count_active_product: item.count_active_product,
          active: false,
        };
      });

      return categories;
    },
    async getColors() {
      const response = await getColors();
      const colors = response.data.colors.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          image: baseUrlStorage + item.image,
          active: false,
        };
      });

      return colors;
    },
    async getProperties() {
      const response = await getProperties();
      return response.data.properties;
    },
    openPropertyBox() {
      if (!this.confirmImage) return

      this.propertyBoxVisibled = !this.propertyBoxVisibled;
    },
    addProperties() {
      let propertiesForFilter = [];
      for (var i = 0; i < properties.elements.length; i++) {

        const type = properties.elements[i].getAttribute("typeforback");
        const id = properties.elements[i].id;
        const value = properties.elements[i].value;

        if (type === "Диапазон") {
          const idAndType = properties.elements[i].id.substring(1);
          const reallyId = idAndType.slice(0, -3);
          const minOrMax = idAndType.substring(idAndType.length - 3)

          if (minOrMax === "max") {
            continue;
          } else {
            let property = {
              PropertyId: reallyId,
              min_value: value,
              max_value: properties.elements[i + 1].value,
              type: type,
            };

            if (property.min_value != 0 || property.max_value != 0) {
              propertiesForFilter.push(property);
            }
          }
        }

        if (type === "Список") {
          const reallyId = properties.elements[i].id.substring(1);
          let property = {
            PropertyId: reallyId,
            value: value,
            type: type,
          };

          if (property.value != 0) {
            propertiesForFilter.push(property);
          }
        }

        if (type === "Текст") {
          const reallyId = properties.elements[i].id.substring(1);
          let property = {
            PropertyId: reallyId,
            value: value,
            type: type,
          };

          if (property.value != 0) {
            propertiesForFilter.push(property);
          }
        }


        if (type === "Чекбокс") {
          const reallyId = properties.elements[i].id.substring(1);
          let property = {
            PropertyId: reallyId,
            value: properties.elements[i].checked,
            type: type,
          };

          if (property.value) {
            propertiesForFilter.push(property);
          }
        }
      }

      this.selectedProperties = propertiesForFilter;
      this.propertyBoxVisibled = false;
      this.filterDoors();
    },
    addPolygon(poly_points) {
      this.edit = true;
      //this.editCanvas();
      this.showMobileDoorsBox = true;

      let polygon = null;
      if(!poly_points)
      {
        this.poligon_points.push([
            {
            x: 1,
            y: 1,
            },
            {
            x: 1,
            y: 150,
            },
            {
            x: 150,
            y: 150,
            },
            {
            x: 150,
            y: 1,
            },
        ]);
        polygon = new fabric.Polygon(
            this.poligon_points[this.poligon_points.length - 1],
            {
            id: this.poligons.length + 1,
            fill: "transparent",
            left: this.canvas.width / 2,
            top: this.canvas.height / 2,
            strokeWidth: 2,
            stroke: "white",
            scaleX: 1,
            scaleY: 1,
            objectCaching: false,
            transparentCorners: false,
            cornerColor: "white",
            strokeDashArray: [1, 5, 1],
            originX: "center",
            originY: "center",
            //absolutePositioned: true
            }
        );
      }
      else
      {
        this.poligon_points.push(poly_points);

        const scaleX = this.canvas.width / this.original_image_size.width
        const scaleY = this.canvas.height / this.original_image_size.height

        // left = min(левая_верхняя_точка.x, левая_нижняя_точка.y) * scale
        const left = Math.min(poly_points[0].x, poly_points[1].x) * scaleX;
        // top = min(левая_верхняя_точка.y, правая_верхняя_точка.y) * scale
        const top = Math.min(poly_points[0].y, poly_points[3].y) * scaleY;

        polygon = new fabric.Polygon(
            poly_points,
            {
            id: this.poligons.length + 1,
            fill: "transparent",
            left,
            top,
            scaleX,
            scaleY,
            strokeWidth: 2,
            stroke: "white",
            objectCaching: false,
            transparentCorners: false,
            cornerColor: "white",
            strokeDashArray: [1, 5, 1],
            originX: "left",
            originY: "top",
            //absolutePositioned: true
            }
        );
      }
      this.canvas.add(polygon);
      let canvas_objects = this.canvas.getObjects();
      let poly = canvas_objects[canvas_objects.length - 1];
      this.canvas.setActiveObject(poly);
      let lastControl = poly.points.length - 1;
      poly.cornerStyle = "circle";
      poly.cornerColor = "rgba(255,255,255,1)";
      poly.controls = poly.points.reduce(function (acc, point, index) {
        acc["p" + index] = new fabric.Control({
          positionHandler: function (dim, finalMatrix, fabricObject) {
            let x =
                fabricObject.points[this.pointIndex].x -
                fabricObject.pathOffset.x,
              y =
                fabricObject.points[this.pointIndex].y -
                fabricObject.pathOffset.y;
            return fabric.util.transformPoint(
              { x: x, y: y },
              fabric.util.multiplyTransformMatrices(
                fabricObject.canvas.viewportTransform,
                fabricObject.calcTransformMatrix()
              )
            );
          },
          touchSizeX: 20,
          touchSizeY: 20,
          cursorStyle: "pointer",
          actionHandler: (function (anchorIndex, fn) {
            return function (eventData, transform, x, y) {
              let buttons = document.getElementById('mobile_first_step_buttons');
              let title = document.getElementById('choose-door-title');

              if (window.screen.width < 1000 && buttons && buttons.style.display === 'none') {
                buttons.style.display = 'flex'
                buttons.style.paddingBottom = '10px'
                title.style.display = 'none'
              }

              let fabricObject = transform.target,
                absolutePoint = fabric.util.transformPoint(
                  {
                    x:
                      fabricObject.points[anchorIndex].x -
                      fabricObject.pathOffset.x,
                    y:
                      fabricObject.points[anchorIndex].y -
                      fabricObject.pathOffset.y,
                  },
                  fabricObject.calcTransformMatrix()
                ),
                actionPerformed = fn(eventData, transform, x, y),
                newDim = fabricObject._setPositionDimensions({}),
                polygonBaseSize = (function (object) {
                  var stroke = new fabric.Point(
                    object.strokeUniform ? 1 / object.scaleX : 1,
                    object.strokeUniform ? 1 / object.scaleY : 1
                  ).multiply(object.strokeWidth);
                  return new fabric.Point(
                    object.width + stroke.x,
                    object.height + stroke.y
                  );
                })(fabricObject),
                newX =
                  (fabricObject.points[anchorIndex].x -
                    fabricObject.pathOffset.x) /
                  polygonBaseSize.x,
                newY =
                  (fabricObject.points[anchorIndex].y -
                    fabricObject.pathOffset.y) /
                  polygonBaseSize.y;
              fabricObject.setPositionByOrigin(
                absolutePoint,
                newX + 0.5,
                newY + 0.5
              );
              return actionPerformed;
            };
          })(
            index > 0 ? index - 1 : lastControl,
            function (eventData, transform, x, y) {
              let polygon = transform.target,
                currentControl = polygon.controls[polygon.__corner],
                mouseLocalPosition = polygon.toLocalPoint(
                  new fabric.Point(x, y),
                  "center",
                  "center"
                ),
                polygonBaseSize = (function (object) {
                  var stroke = new fabric.Point(
                    object.strokeUniform ? 1 / object.scaleX : 1,
                    object.strokeUniform ? 1 / object.scaleY : 1
                  ).multiply(object.strokeWidth);
                  return new fabric.Point(
                    object.width + stroke.x,
                    object.height + stroke.y
                  );
                })(polygon),
                size = polygon._getTransformedDimensions(0, 0),
                finalPointPosition = {
                  x:
                    (mouseLocalPosition.x * polygonBaseSize.x) / size.x +
                    polygon.pathOffset.x,
                  y:
                    (mouseLocalPosition.y * polygonBaseSize.y) / size.y +
                    polygon.pathOffset.y,
                };
              polygon.points[currentControl.pointIndex] = finalPointPosition;
              return true;
            }
          ),
          actionName: "modifyPolygon",
          pointIndex: index,
        });
        return acc;
      }, {});
      poly.hasBorders = false;

      this.poligons.forEach((item) => {
        item.active = false;
      });

      this.poligons.push({
        active: true,
        image_url: null,
        canvas_index: poly.id,
      });
      //чтобы перемещать рамки закоментить этот ивент
      if (this.isMobileOrTablet) {
        this.canvas.on("object:moving", (e) => {
          e.target.lockMovementX = true;
          e.target.lockMovementY = true;
        });
      }

      this.canvas.requestRenderAll();
      this.canvas.add(poly);
      this.updateActiveObject();
    },
    addDoorImageInPolygon(door) {
      let img_url = door && door.image ? door.image : null

      if (this.modelMenuOpen) {
        this.modelMenuOpen = false;
      }

      this.poligons.forEach((item) => {
        if (item.active === true && img_url) {
          item.image_url = img_url;
          item.door_name = door.name
        }
      });
      const url = img_url ? img_url : require("../assets/test.webp");
      let shapes = this.canvas.getObjects();
      this.canvas.requestRenderAll();
      this.edit = false;
      this.blockCanvas();
      shapes.forEach((shape) => {
        let polygon = this.poligons.find((o) => o.canvas_index === shape.id);
        if (polygon.image_url) {

        let image = new Image();

        if (enviroment === "prod") {
          image.crossOrigin = "Anonymous";
        }

        image.onload = () => {
          let ctx = this.canvas.getContext("2d");
          let p = new Perspective(ctx, image);
          setTimeout(() => {
            p.draw([
              [shape.oCoords.p0.x, shape.oCoords.p0.y],
              [shape.oCoords.p3.x, shape.oCoords.p3.y],
              [shape.oCoords.p2.x, shape.oCoords.p2.y],
              [shape.oCoords.p1.x, shape.oCoords.p1.y],
            ]);
          }, 300)
        };

        let src = polygon.image_url ? polygon.image_url : url;
        if(!src.startsWith(baseUrlStorage))
            src = baseUrlStorage + src;
        image.src = src;
        }
      });
    },
    blockCanvas() {
      let shapes = this.canvas.getObjects();
      this.canvas.discardActiveObject();
      this.canvas.requestRenderAll();

      shapes.forEach((shape) => {
        shape.evented = false;
        shape.stroke = "transparent";
      });
    },
    editCanvas() {
      this.updateActiveObject();
    },
    saveImage() {
      const canvas = document.getElementById("c").toDataURL("image/jpeg");
      const link = document.createElement("a");
      link.download = "line-doors.jpeg";
      link.href = canvas;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    addNewDoor() {
      this.addPolygon();
      this.updateActiveObject();
    },
    removeDoor(index) {
      let remove_index = this.poligons[index].canvas_index;
      this.canvas.discardActiveObject();
      let objects = this.canvas.getObjects();

      if (objects.length <= 2) {
        this.canvas.remove(objects[1]);
        this.canvas.remove(objects[0]);
      } else {
        for (let i = objects.length - 1; i >= 0; i--) {
          if (objects[i].id && objects[i].id === remove_index) {
            objects[i].off("deselected", (e) => {});
            objects[i].off("selected", (e) => {});
            this.canvas.remove(objects[i]);
          }
        }
      }
      if (index < this.poligons.length - 1 && this.poligons[index].active) {
        this.poligons[index].active = true;
    }
      this.poligons.splice(index, 1);
      this.canvas.requestRenderAll();
      this.updateActiveObject();
    },
    setActive(idx) {
      this.poligons.forEach((item, index) => {
        if (index === idx) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      if (this.edit) {
        this.updateActiveObject();
      }
    },
    updateActiveObject() {
      let active_object = this.poligons.find((o) => o.active === true);
      this.canvas.discardActiveObject();
      this.canvas.forEachObject((obj) => {
        if (active_object && obj.id && obj.id === active_object.canvas_index) {
          obj.evented = true;
          obj.stroke = "white";
          this.canvas.setActiveObject(obj);
        } else {
          obj.evented = false;
          obj.stroke = "transparent";
        }
      });
      this.canvas.requestRenderAll();
    },
    saveFirstPolygon() {
      this.leftBarWithDoors = true;
      this.doorChoiceVisibled = true;
      let width = window.screen.width > 1000
        ? document.getElementById("image_block").parentElement.clientWidth * 0.7
        : document.getElementById("image_block").parentElement.clientWidth
      this.resizeHandler(width);
      this.edit = true;
      this.showMobileDoorsBox = true;
      this.editCanvas();
      this.confirmImage = true;

      if (window.screen.width < 1000 &&
          this.getReferrerDoorInfo &&
          this.getReferrerDoorInfo.length > 0 &&
          this.getReferrerDoorInfo[0].image
      ) {
        this.poligons[0].image_url = this.getLink(this.getReferrerDoorInfo[0].image);
        //this.editPolygon(); // не понял зачем это тут, но из-за этого границы двери не отображаются на мобилке
      }
    },
    getLink(path) {
      return baseUrlStorage + path;
    },
    editPolygon() {
      this.edit = !this.edit;
      if (this.edit) {
        this.editCanvas();
        this.showMobileDoorsBox = true;
      } else {
        this.blockCanvas();
        this.addDoorImageInPolygon();
        this.showMobileDoorsBox = false;
      }
    },
    insertDoor() {
        this.edit = false;
        this.blockCanvas();
        this.addDoorImageInPolygon(this.getReferrerDoorInfo ? this.getReferrerDoorInfo[0] : undefined);
        this.showMobileDoorsBox = false;
    },
    openFullPage() {
      document.querySelector('html').style = "background: #000";
      this.isFullpage = true;
      window.scrollTo(0, 0);
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      let moreScreenWidth =
        this.original_image_size.width > window.screen.width;
      let moreScreenHeight =
        this.original_image_size.height > window.screen.height;
      let width = this.original_image_size.width;
      let height = this.original_image_size.height;

      if (this.original_image_size.type === "gorizontal") {
        width = moreScreenWidth
          ? window.screen.width
          : this.original_image_size.width;
        height = null;
      } else if (this.original_image_size.type === "vertical") {
        height = moreScreenHeight
          ? window.screen.height
          : this.original_image_size.height;
        width = null;
      } else {
        height = moreScreenHeight
          ? window.screen.height
          : this.original_image_size.height;
        width = moreScreenHeight
          ? window.screen.height
          : this.original_image_size.height;
      }
      this.resizeHandler(width, height);
      this.addDoorImageInPolygon()
    },
    closeFullPage() {
      document.querySelector('html').style = "background: #fff"
      this.isFullpage = false;
      document.getElementsByTagName("body")[0].style.overflow = "visible";
      setTimeout(this.resizeHandler(), 500);
    },
    resizeHandler(width = null, height = null) {
      //рассчитываю новую ширину и высоту
      const newWidth = width
        ? width
        : document.getElementById("image_block").parentElement.clientWidth;
      const newHeight = height
        ? height
        : document.getElementById("image_block").clientHeight;

      if (this.canvas.width !== newWidth || this.canvas.height !== newHeight) {
        //вычисляю скейл (во сколько раз отличаются текущая и новая ширины)
        const scaleX = newWidth / this.canvas.width;
        let objects = this.canvas.getObjects();
        //пробегаю по всем объектам канваса (рамки)

        for (let i in objects) {
          //ЭТО КОСТЫЛЬ НАДО БЫ СДЕЛАТЬ ХОРОШО, НО ПОЧЕМУ ТО ДОБАВЛЯЕТ ПО ДВА ОБЪЕКТА ДЛЯ ОДНОГО ПОЛИГОНА
          if (i % 2 === 0) {
            continue;
          }
          //уменьшаю/увеличиваю размер рамки
          objects[i].scaleX *= scaleX;
          objects[i].scaleY *= scaleX;

          //вычисляю новые координаты центра
          objects[i].left = objects[i].left * scaleX;
          objects[i].top = objects[i].top * scaleX;
          //пересчитываю остальные координаты в зависимости от измененных данных
          objects[i].setCoords();
        }
        let obj = this.canvas.backgroundImage;
        //скейлю также фоновую картинку
        if (obj) {
          obj.scaleX = obj.scaleX * scaleX;
          obj.scaleY = obj.scaleY * scaleX;
        }

        this.canvas.discardActiveObject();
        //устанавливаю новую ширину и высоту для самого канваса
        this.canvas.setWidth(this.canvas.getWidth() * scaleX);
        this.canvas.setHeight(this.canvas.getHeight() * scaleX);
        //перерисовываю
        this.canvas.renderAll();
        //вычисляю смещение
        this.canvas.calcOffset();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.show_doors_control {
  display: flex !important;
}
.header__mobile {
  display: none !important;
}
.mobile-ext-functions {
  display: none;
}
.mobile_filter_show {
  display: block !important;
}
.mobile-color-list-wrapper {
  display: none;
}
.mobile_filter_menu_wrapper {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  z-index: 10000;
}

.open-filter-mobile {
  display: none;
  width: 100%;
  .open-filter__button {
    width: 250px;
    border: 2px solid #ffffff;
    background: rgba(82,82,82,47%);
    padding: 10px;
    text-align: center;
    margin: 0 auto;

  }
}

.properties_buttons_wrapper{
  display: flex;
  justify-content: space-between;
}
.doors_box_mobile{
  .row{
    color: white;
    justify-content: center;
    padding-top: 40px;
  }
}
.new_doors_box_mobile{
    margin-bottom: 40px;

    .row{
        color: white;
        padding-bottom: 20px;
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    .row::-webkit-scrollbar {
        height: 8px;
    }
}
.menu_right_link_content_bottom_mobile{
  display: none;
}
.selectedCategories{
  .item{
    display: flex;

    .item_button{
      background: rgba(255, 255, 255, 0.21);
      border-radius: 4px;
      padding: 10px 20px;
      width: fit-content;
      margin-top: 10px;
      color: #fff;
    }
    .deleteSelectedCategories{
      text-align: center;
      cursor: pointer;
      height: 16px;
      width: 16px;
      background: #3498db;
      border-radius: 50%;
      margin-left: -5px;
      margin-top: 2px;
      color: #fff;
      display: none;
    }
  }

  .item:hover{
    .deleteSelectedCategories{
      display: block;
    }
  }

  .item:hover{
    .deleteSelectedCategories{
      display: inline;
    }
  }
}

.next_block{
  text-align: center;
  margin-top: -25px;
  height: 25px;
  margin-right: 20px;
  cursor: pointer;

  img{
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) -13.64%, #FFFFFF 42.29%);
    padding-left: 42%;
    padding-right: 42%;
    height: 100%;
  }
}

.empty_message_white{
  text-align: center !important;
  color: white;
}

.empty_message{
  text-align: center;
  margin-top: 30px;
}

.d-none {
  display: none !important;
}

.visible {
  display: block !important;
}

.arrow-reverse {
  transform: rotate(180deg);
}

.fullpage {
  position: absolute !important;
  width: 100vw !important;
  height: 100vh !important;
  top: 0 !important;
  left: 0 !important;
  background-color: black !important;
  z-index: 10000 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullpage_control_wrapper {
  position: absolute;
  top: 20px;
  left: 0;
  display: flex;
  flex-direction: column;
  z-index: 10010;
  div {
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 0px 5px 5px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
    cursor: pointer;
  }
}
.fullpage_control_doors_wrapper {
  position: absolute;
  top: 75%;
  left: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  z-index: 10010;
        .doors_control {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .door_button {
          border: 1px solid #FFFFFF;
          border-radius: 9px;
          padding: 10px 20px;
          font-weight: 400;
          font-size: 17px;
          line-height: 20px;
          text-align: center;
          color: white;
          cursor: pointer;
          margin-right: 20px;
          position: relative;
          margin-bottom: 10px;

          &_remove {
            background-color: white;
            position: absolute;
            top: -10px;
            right: -10px;
            border: none;
            border-radius: 9px;
            width: 18px;
            height: 18px;
            padding: 3px;
            padding-top: 2.36px;
            cursor: pointer;
          }
        }
        .door_active {
          border: 2px solid white;
        }
        .add_door_button {
          border: 1px solid white;
          border-radius: 9px;
          padding: 10px 10px;
          position: relative;
          margin-bottom: 10px;
        }
      }
}

.diapason-input-box {
  display: flex;

  input {
    width: 80px;
    border: 0.5px solid #959494;
    margin-left: 10px;
    margin-right: 5px;
    border-radius: 5px;
  }
}

.canvas-margin {
  margin: auto !important;
}

.filter-item-box {
  padding: 10px 0px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #d3d1d1;

  select {
    font-size: 16px;
    border: none;
  }
}

.canvas-container {
  margin: auto;
}

.menu_right_mobile_header {
  display: none;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  /* identical to box height */
  /* black */
  color: #181818;
}
.menu_right_link_content_colors{
  margin-left: -192px !important;
}
.menu_right_link_content {


  position: relative;
  background: #ffff;
  width: 414px;
  margin-left: -250px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 0px 13px rgba(107, 101, 95, 0.1);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 26px 23px 23px 32px;
  z-index: 5000;
  margin-top: -10px;

  .menu_right_link_content_top {
    h3 {
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 29px;
      color: #181818;
      margin-bottom: 15px;
    }
    .property-list {
      margin-bottom: 30px;
      margin-top: 20px;
    }
    .color-list {
      margin-bottom: 20px;
      border-bottom: 1px solid #F0F0F0;
      padding-bottom: 10px;

      &-item {
        border-radius: 3.77869px;
        width: 63.64px;
        height: 63.64px;
        display: inline-block;
        margin-right: 7px;

        img {
          border-radius: 3.77869px;
          width: 63.64px;
          height: 63.64px;
        }
      }

      .delete {
        display: none;
      }

      .active {
        .delete {
          display: block;
          position: absolute;
          color: white;
          margin-top: -5px;
          margin-left: 53px;
          text-align: center;
          cursor: pointer;
          height: 16px;
          width: 16px;
          background: #3498db;
          border-radius: 50%;
        }

        img {
          border: 1.5px solid #3498db;
          border-radius: 5px;
        }
      }

      img {
        margin-right: 6px;
        margin-bottom: 4px;
        border: 1.5px solid #fff;
        border-radius: 5px;
        cursor: pointer;
      }

      img:hover {
        border: 1.5px solid #3498db;
        border-radius: 5px;
      }
    }
  }
  .menu_right_link_content_bottom {
    display: flex;
    justify-content: flex-end;

    .button {
      width: fit-content;
    }
  }
}

.doors_box_mobile {
  display: none;

  .item {
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
    width: 100%;
    padding: 20px;

    img {
      width: 60px;
      height: 120px;
    }

    p {
      font-family: "Arial";
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 17px;
      /* or 131% */
      text-align: center;
      color: #1a1a1a;
      margin-top: 10px;
    }

    span {
      font-family: "Arial";
      font-style: normal;
      font-weight: 400;
      font-size: 19px;
      line-height: 25px;
      /* identical to box height, or 132% */
      text-align: center;
      color: #1a1a1a;
    }
  }
}

.new_doors_box_mobile {
    display: none;

    .item {
        text-align: center;
        background: #ffffff;
        border-radius: 14px;
        width: 100%;
        padding: 14px;
        height: 230px;

        img {
            width: 60px;
            height: 120px;
        }

        p {
            font-family: "Arial";
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 17px;
            /* or 131% */
            text-align: center;
            color: #1a1a1a;
            margin-top: 10px;

            -ms-text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            overflow: hidden;
            -ms-line-clamp: 3;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            display: -webkit-box;
            display: box;
            word-wrap: break-word;
            -webkit-box-orient: vertical;
            box-orient: vertical;
        }

        span {
            font-family: "Arial";
            font-style: normal;
            font-weight: 400;
            font-size: 19px;
            line-height: 25px;
            /* identical to box height, or 132% */
            text-align: center;
            color: #1a1a1a;
        }
    }
}

.doorChoiceBlock {
  width: 30%;
  margin-right: 25px;

  .doors_box {
    height: 773px;
    overflow-y: auto;
    padding-right: 15px;

    .item {
      img {
        width: 116.75px;
        height: 215px;
      }

      background: #ffffff;
      box-sizing: border-box;
      cursor: pointer;
      border-radius: 6px;
      margin-bottom: 15px;
      text-align: center;
      padding: 20px 27px;
      border: 1px solid #fff;

      p {
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        /* or 160% */

        text-align: center;

        color: #1a1a1a;
      }

      span {
        font-style: normal;
        font-weight: 600;
        font-size: 19px;
        line-height: 25px;
        /* identical to box height, or 132% */
        color: #1a1a1a;
      }
    }

    .item:hover {
      border: 1px solid #3498db;
    }

    .active {
      border: 1px solid #3498db;
    }
  }
  .search_box {
    margin-bottom: 15px;

    img {
      position: absolute;
      margin-top: 8px;
      margin-left: 8px;
    }
    input {
      height: 41.82px;
      width: 100%;
      background: #ffffff;
      border-radius: 6px;
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
      /* identical to box height */
      padding-left: 46px;
      /* grey */
      border: none;
      color: #969696;
      background-image: url('@/assets/icon/search.svg');
      background-repeat: no-repeat;
      background-position-x: 5%;
      background-position-y: center;
    }
  }
}

.model-menu {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 100vh;
  background-color: #262626;
  padding: 30px 140px 80px 140px;
  overflow-y: visible;
  z-index: 500;

  .model-menu-top-mobile {
    display: none;
    background: rgba(255, 255, 255, 0.21);
    border-radius: 4px;
    padding: 16px 25px;
    margin-bottom: 30px;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    /* identical to box height */
    text-transform: uppercase;
    color: #ffffff;

    .text {
      margin-top: 1px;
      margin-left: 8px;
    }

    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  &-list {
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 21px;
    /* identical to box height, or 124% */
    color: #ffffff;
    column-count: 3;

    &-item {
      width: 80%;
      min-height: 30px;
      padding-bottom: 15px;

      .subcategories-box {
        margin-bottom: 20px;
        margin-top: 20px;
        padding-left: 15px;
        border-left: 0.6px solid #ffffff;

        .subcategory {
          font-style: normal;
          font-weight: 400;
          font-size: 17px;
          line-height: 28px;
          /* or 168% */
          color: #ffffff;
          cursor: pointer;
        }
      }

      &-top {
        display: flex;
        cursor: pointer;
        justify-content: space-between;
        border-bottom: 1px solid #363636;
      }
    }
  }

  &-top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 30px;

    .logo-wrapper {
      margin-top: -10px;
    }
    .menu_left_link {
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
      /* identical to box height */
      text-transform: uppercase;
      color: #ffffff;
      text-decoration: none;
      display: block;
      padding: 12px 38px;
      background: rgba(255, 255, 255, 0.21);
      border-radius: 4px;
      margin-right: -130px;
    }
    .close {
      cursor: pointer;
    }
  }
}
.control_icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  img {
    margin: 0 auto;
  }
}

.top_content {
  background-image: url("../assets/images/backgrounds/choice_background.jpeg");
  height: 675px;

  .logo-wrapper {
    padding-top: 25px;
    text-align: center;
    padding-bottom: 60px;
  }

  .menu {
    background: rgba(255, 255, 255, 0.21);
    border-radius: 4px;
    padding: 0px 30px;
    display: flex;
    height: 68px;
    justify-content: space-between;
    &_left {
      display: flex;
      .burger_wrapper {
        padding: 25px 0px;
      }
      &_wrapper {
        margin-left: 70px;
        display: flex;
      }
      &_link {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        /* identical to box height */
        text-transform: uppercase;
        color: #ffffff;
        padding: 20px 5px;
        display: block;
        margin-right: 20px;
      }
      .active {
        border-bottom: 4px solid #3498db;
      }
    }
    &_right {
      display: flex;

      &_link {
        display: block;
        padding: 20px 5px;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        /* identical to box height */
        color: #ffffff;
        margin-left: 40px;
      }

      &_mobile {
        display: none;
      }

      &_link::after {
        content: "▼";
        font-size: 10px;
        margin-left: 7px;
      }
    }
    a {
      text-decoration: none;
    }
  }
}

.main_content {
  .photo_content {
    display: flex;
    background: #f4f4f4;
    border-radius: 5px;
    margin-top: -400px;
    padding: 40px 30px;

    &_main {
      width: 100%;
      //margin: 0 auto;
    }
    &_main-choice {
      width: 70% !important;
    }

    h4 {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 29px;
      /* identical to box height */
      text-transform: uppercase;
      text-align: center;
      color: #181818;
      margin-bottom: 35px;
    }

    .photo_wrapper_block {
      position: relative;
      margin-bottom: 35px;
    }

    .photo_control_wrapper {
      display: flex;
      width: auto;
      padding: 10px 16px;
      justify-content: space-between;
      background: rgba(155, 89, 182, 1);
      border-radius: 4px;
      position: absolute;
      top: 20px;
      left: 20px;
      z-index: 100;
    }

    .photo_control_wrapper-mobile {
      display: none;
      padding: 10px;
      justify-content: space-between;
      background: rgba(155, 89, 182, 1);
      border-radius: 4px;
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 100;
      img {
        width: 30px;
        height: 30px;
      }
    }

    .photo_fullpage_control {
      position: absolute;
      bottom: 20px;
      right: 20px;
      z-index: 100;
    }

    &_buttons_wrapper {
      display: flex;
      justify-content: flex-end;

      .doors_control {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .door_button {
          border: 1.4px solid #969696;
          border-radius: 4px;
          padding: 10px 20px;
          font-weight: 400;
          font-size: 17px;
          line-height: 20px;
          text-align: center;
          color: #969696;
          cursor: pointer;
          margin-right: 20px;
          position: relative;
          margin-bottom: 15px;

          &_remove {
            background-color: #3498db;
            position: absolute;
            top: -10px;
            right: -10px;
            border: none;
            border-radius: 9px;
            width: 18px;
            height: 18px;
            padding: 3px;
            padding-left: 2.16px;
            cursor: pointer;
          }
        }
        .door_active {
          border: 2.4px solid #3498db;
        }
        .add_door_button {
          border: 1.4px solid #969696;
          border-radius: 4px;
          padding: 10px 10px;
          position: relative;
          height: 44px;
          cursor: pointer;
        }
      }

      .button_cancel {
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 15px;
        /* identical to box height, or 88% */
        padding: 15px 40px;
        text-align: center;
        color: #2285c4;
        cursor: pointer;
      }
    }

    &_control {
      justify-content: space-between;
    }
  }
}
  .desktop_button {
    display: flex;
    align-items: center;
    img {
      margin-right: 10px;
    }
  }
  .mobile_button {
    display: none;
  }

  .border-complete-button {
    border: none;
    background: none;
    color: #fff;
    font-size: 16px;
    white-space: nowrap;
    height: 29px;
    padding: 0px 10px;
  }

@media screen and (max-width: 1000px) {
  .doors_control_wrapper {
    display: none !important;
  }
  .show_doors_control {
    display: flex !important;
  }
  .data-v-tooltip:hover::after {
    position: absolute;
    top: 75%;
  }
  .mobile-ext-functions {
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    display: block !important;
  }
  .mobile-color-list-wrapper {
    display: flex;
  }
  .photo_control_wrapper-mobile {
    display: flex !important;
  }
  .header__mobile {
    display: block !important;
  }
  #mobile_buttons_hidden {
    display: none;
  }
.open-filter-mobile {
  display: block;
  position: absolute;
  bottom: 15px;
  color: #ffffff;
  z-index: 105;
}

.color-list {
  height: 150px;
  overflow-y: scroll;
}

  .photo_fullpage_control {
    display: none;
  }

.doors_control{
  flex-direction: column !important;

  .add_door_button{
    width: fit-content !important;
  }
}

.properties_buttons_wrapper{
  display: block !important;
}
.mobile_button_order{
  background: none !important;

  img{
    background: #3498DB;
    padding: 15px;
    height: auto !important;
    width: auto !important;
    border-radius: 50%;
  }
}


.subcategories-box{
  height: 50vh !important;
  overflow-y: auto !important;
}


.menu_right_link_content{
  position: absolute !important;
  margin-top: 0px;
}

.menu_right_link_content_bottom_mobile{
  display: block;
}

#properties_mobile{
  box-shadow: none;
  border: none;
}

.menu_right_link_content_bottom{
  display: none !important;
  border: none;
}

.container {
  padding-left: 0;
  padding-right: 0;
}
.main_content {
  .photo_content {
    margin-top: 20px;
    &_main-choice {
      width: 100% !important;
    }
  }
}
.add_door_button {
  height: 40px;
  padding: 10px 13px !important;
  img {
    width: 20px;
    height: 20px;
  }
}
.door_button {
  height: 40px;
  padding: 8.5px 21px !important;
}
  .canvas-container {
    canvas {
      width: 100% !important;
    }
  }
  .mobile_button {
    width: 62px;
    height: 62px;
    background: #3498DB;
    border-radius: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 3px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
    }
  }
  .desktop_button {
    display: none;
  }
  .menu_right_link_content {
    width: 100vw !important;
    margin-left: 0 !important;
    z-index: 5000;
    left: 0 !important;
    top: 71px !important;
    margin-bottom: 25px !important;
    border-bottom: 1px solid #f0f0f0 !important;
    padding-bottom: 20px !important;
  }

  .menu_right_link_content_top {
    padding-bottom: 20px;
    margin-bottom: 25px;
    //border-bottom: 1px solid #f0f0f0;
  }

  .menu_right_link_content_bottom {
    display: block;
  }
  .menu_right_link_box_open_in_mobile {
    flex-direction: column;

    .menu_right_mobile_header {
      display: block !important;
    }
  }
  .menu_right_mobile_header {
    padding: 20px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
  }

  .menu_right_link_box_open_in_mobile {
    .menu_right_link_box {
      .menu_right_link {
        margin-left: 20px !important;
        margin-right: 20px !important;
        border-bottom: 1px solid #f0f0f0;
        display: flex !important;
        justify-content: space-between;
      }

      .menu_right_link::after {
        content: ">";
        font-size: 22px;
      }
    }
  }

  .doors_box_mobile {
    display: block !important;
    position: absolute;
    top: 171px;
    background: #262626;
    z-index: 5000;
    min-height: 100vh;
    width: 100vw;
    padding-bottom: 30px;
    padding: 0 13px;
  }

    .new_doors_box_mobile {
        display: block !important;
        z-index: 5000;
        padding-bottom: 30px;
        padding: 0 13px;
        position: relative;
        margin-top: -60px;
        .close-doors-box {
          position: absolute;
          right: 0;
          top: -50px;
          width: 40px;
          height: 40px;
          background: #3498DB;
          border-radius: 50%;
          font-size: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            height: 20px;
            width: 20px;
          }
        }
        .row {
            overflow-x: auto;
            flex-wrap: nowrap !important;
        }
    }

  .doorChoiceBlock {
    display: none !important;
  }
  .subcategories-box {
    position: fixed !important;
    top: 150px !important;
    padding-top: 27px !important;
    min-height: 100vh !important;
    left: 0px !important;
    width: 100vw !important;
    padding-left: 33px !important;
    background: #262626 !important;
    padding-right: 33px !important;

    .subcategory {
      border-bottom: 1px solid #363636 !important;
      padding-bottom: 13px !important;
      margin-bottom: 13px !important;
    }
  }

  .top_content {
    height: auto;
    background: none;
    .container {
      display: none;
    }
  }

  .top_content .menu_left_wrapper {
    margin-left: 30px !important;
  }

  .model-menu {
    padding-left: 0 !important;
    padding-right: 0 !important;

    .model-menu-top-mobile {
      display: flex !important;
    }

    .model-menu-top {
      padding-left: 25px !important;
      padding-right: 25px !important;

      .close img {
        height: 30px !important;
      }
    }

    .model-menu-list {
      padding-left: 25px !important;
      padding-right: 25px !important;
      column-count: 1 !important;

      .model-menu-list-item {
        width: 100% !important;
      }
    }
  }
  .model-menu-top {
    .menu_left_wrapper {
      display: none !important;
      position: absolute !important;
      left: -9999px !important;
      top: -9999px !important;
    }
  }
  .menu_right_link {
    display: none !important;
  }
  //.photo_wrapper_block {
  //  height: auto !important;
  //}
  .menu_right_mobile {
    display: flex !important;
    flex-direction: column;
    justify-content: center;
  }

  .menu_right_link_box_open_in_mobile {
    position: fixed;
    background: #fff;
    left: 0;
    top: 0;
    z-index: 500;
    min-height: 100vh;
    width: 100vw;

    .menu_right_link {
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 29px;
      /* identical to box height */
      /* black */
      color: #181818;
    }

   // .menu_right_mobile {
   //   display: none !important;
   // }
    .menu_right_link {
      display: block !important;
    }
  }
}
  @media screen and (max-width: 576px){
    .container {
      .photo_content {
        padding: 20px;
      }
    }
  }

  @media screen and (max-width: 480px){
    .new_doors_box_mobile {
      .item p {
        font-size: 10px;
      }
    }
  }

  @media screen and (max-width: 375px){
    .top_content .menu_left .active{
      font-size: 16px !important;
    }
  }

  @media screen and (min-width: 1001px){
    #mobile_first_step_buttons{
        display: none;
    }
  }
</style>
